<template>
    <vs-popup class="holamundo add-related-assets-popup" title="Add related assets" :active.sync="isOpen">
        <div class="flex items-center relative justify-center" style="margin-bottom: 20px">
            <vs-input
                    icon-pack="feather"
                    icon="icon-search"
                    icon-no-border
                    placeholder="Search"
                    v-model="searchQuery"
                    class="is-label-placeholder"
                    v-on:keyup="getSearchData"
            />
        </div>
        <div class="add-related-assets-block">
            <div class="vx-row pt-base px-5 flex-grow">
                <div  class="vx-col custom-asset-card mb-base w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 cursor-pointer" v-for="(item, index) in items" :key="index" v-if="item._id !== $route.params.id">
                    <vx-card @click="selectItem(item)" :class="{ 'selected-item': selectedItems.indexOf(item) != -1}">
                        <div slot="no-body" class="card-img-block">
                            <div class="asset-img-section" style="min-height: 100px">
                                <img :src="item.thumbnail ? item.thumbnail : $root.getDefaultThumbnail(item.asset_type)" alt="content-img" class="responsive card-img-top">
                            </div>
                            <vs-chip :color="item.asset_type === 'video' ? 'danger' : item.asset_type === 'image' ? 'success' : 'primary'" class="item-category">{{ item.asset_type }}</vs-chip>
                            <vs-chip color="primary" class="item-type" v-if="item.variants && item.variants.length && item.variants.length > 1">{{ item.variants.length }}</vs-chip>
                        </div>
                        <h5 class="mb-2">{{ item.title }}</h5>
                        <p class="text-grey">{{ item.description }}</p>
                    </vx-card>
                </div>
                <div class="w-full" v-if="!items || items.length === 0" style="text-align: center; font-size: 20px; margin-top: 10px;">
                    No results
                </div>
                <div class="pagination-block">
                    <vs-pagination :total="totalPages" :max="7" v-model="currentPage" class="mt-base" v-if="totalPages > 1" @change="handlePaginationChange"></vs-pagination>
                </div>
            </div>
        </div>
        <div >
            <vs-button class="mt-4 mr-2 shadow-lg" :disabled="!selectedItems.length > 0" type="gradient" @click="add">Add</vs-button>
        </div>
    </vs-popup>
</template>

<script>
    export default{
        props: {
            popupActive: {
                type: Boolean,
                default: false
            },
            relatedAssets: {
                type: Array,
                default: () => []
            },

        },
        components: {

        },
        data () {
            return {
                isOpen: true,
                searchQuery: '',
                debounce: false,
                items: [],
                currentPage: 1,
                totalItems: 0,
                itemsPerPage: 8,
                totalPages: 0,
                isMounted: false,
                selectedItems: [],
                isAdd: false
            }
        },
        computed: {

        },
        mounted () {
            this.search();
        },
        created () {

        },
        watch: {
            isOpen(newVal) {
                if (!newVal){
                    setTimeout(() => {
                        this.$emit('close');
                    }, 100)
                }
            }
        },
        methods: {
            add() {
                this.$emit('addRelatedAssets', this.selectedItems);
                this.isOpen = false;
            },
            handlePaginationChange(page) {
                if (this.isMounted) {
                    this.search();
                }
            },
            selectItem(item) {
                if (this.selectedItems.indexOf(item) !== -1) {
                    this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
                } else {
                    this.selectedItems.push(item);
                }
            },
            getSearchData() {
                clearTimeout(this.debounce)
                this.debounce = setTimeout(() => {
                    this.search();
                }, 1000)
            },
            search() {
                let url = '/assets/search';

                let qObj = {
                    _limit: this.itemsPerPage,
                    _start: (this.currentPage - 1) * this.itemsPerPage
                };

                if (this.searchQuery) {
                    qObj._search = this.searchQuery;
                }

                let _id_nin = [];
                if (this.$route.params.id) {
                    _id_nin.push(this.$route.params.id);
                }
                if (this.relatedAssets.length) {
                    _id_nin.push(...this.relatedAssets.map(a => a._id))
                }
                if (_id_nin.length) {
                    qObj._id_nin = JSON.stringify(_id_nin);
                }

                let q = "?" + new URLSearchParams(qObj).toString()
                url += q;
                this.$axios.get(url).then(res => {
                    this.items = res.data;
                    if (!this.isMounted) {
                        this.isMounted = true;
                    }
                }).catch(e => {
                    console.log('catch_search', e)
                })

                let url2 = '/assets/search/count' + q

                this.$axios.get(url2).then(res => {
                    this.totalItems = res.data;
                    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage)
                }).catch(e => {
                    console.log('catch_search', e)
                })
            },
        }
    }
</script>
